import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2024 AL2 Loan Consultant. All Rights Reserved.</p>
        </footer>
    );
}

export default Footer;
